﻿import { Directive, Input, Output, EventEmitter, ElementRef, HostListener, OnInit, AfterViewInit, Renderer, OnDestroy } from '@angular/core';

@Directive({
    selector: '[enter-to-button]'
})
export class EnterToButtonDirective {

    private sortProperty: string;
    nativeElement: HTMLElement;

    constructor(private elRef: ElementRef, private renderer: Renderer) {
        this.nativeElement = this.elRef.nativeElement;
    }


    @HostListener('keyup', ['$event']) keyupInput(event: any) {
        if (event.keyCode === 13) {
            this.clickButton(this.nativeElement);
        }
    }

    clickButton(ele: HTMLElement) {
        if (ele.parentElement) {
            //try find button:
            let button = ele.parentElement.getElementsByTagName("button")[0];

            if (button) {
                button.click();
            }
            else {
                this.clickButton(ele.parentElement);
            }
            
        }
    }

}